import React from 'react';
import './NearbyPlacesSection.css';
import { FaMapMarkerAlt, FaSubway, FaMonument, FaWater, FaUniversity, FaBuilding, FaWalking, FaPalace } from 'react-icons/fa';

const NearbyPlacesSection = () => {
  // Nearby places data with accurate distances and categories
  const nearbyPlaces = [
    { 
      id: 1, 
      name: 'Rasoolpura Metro Station', 
      distance: '500m', 
      description: 'Nearest metro connectivity',
      category: 'transport',
      icon: FaSubway,
      walkTime: '6 min walk'
    },
    { 
      id: 2, 
      name: 'Paradise Metro Station', 
      distance: '1km', 
      description: 'Major metro interchange',
      category: 'transport',
      icon: FaSubway,
      walkTime: '12 min walk'
    },
    { 
      id: 3, 
      name: 'Hussain Sagar Lake', 
      distance: '5km', 
      description: 'Heart-shaped lake with Buddha statue',
      category: 'attraction',
      icon: FaWater,
      walkTime: '15 min drive'
    },
    { 
      id: 4, 
      name: 'Salar Jung Museum', 
      distance: '9km', 
      description: 'World-famous museum with artifacts',
      category: 'museum',
      icon: FaUniversity,
      walkTime: '25 min drive'
    },
    { 
      id: 5, 
      name: 'Charminar', 
      distance: '10km', 
      description: 'Iconic 16th-century monument',
      category: 'monument',
      icon: FaMonument,
      walkTime: '30 min drive'
    },
    { 
      id: 6, 
      name: 'Chowmahalla Palace', 
      distance: '11km', 
      description: 'Former royal palace complex',
      category: 'palace',
      icon: FaBuilding,
      walkTime: '35 min drive'
    }
  ];

  return (
    <section className="nearby-places-section">
      <div className="nearby-places-container">
        <h2 className="nearby-places-title">Explore Nearby</h2>
        <p className="nearby-places-subtitle">Popular destinations close to our location</p>
        
        <div className="nearby-places-grid">
          {nearbyPlaces.map(place => {
            const IconComponent = place.icon;
            return (
              <div key={place.id} className={`nearby-place-card ${place.category}`}>
                <div className="place-header">
                  <div className="place-icon">
                    <IconComponent />
                  </div>
                  <div className="place-distance-badge">
                    {place.distance}
                  </div>
                </div>
                <div className="place-content">
                  <h3 className="place-name">{place.name}</h3>
                  <p className="place-description">{place.description}</p>
                  <div className="place-timing">
                    <FaMapMarkerAlt className="location-icon" />
                    <span className="walk-time">{place.walkTime}</span>
                  </div>
                </div>
                <div className="place-category-tag">
                  {place.category}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default NearbyPlacesSection;
